import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import type { Role } from '@/shared/api/types';
import { Initials } from '@/shared/components/Initials';

interface Props { name: string; role: Role; compact: boolean; onSignOut: () => void }

export function NavAccount({ name, role, compact, onSignOut }: Props) {
  const roleLabel = role.replace('_', ' ');
  const signOut = (
    <Tooltip title="Sign out" placement={compact ? 'right' : 'top'}>
      <IconButton aria-label="Sign out" onClick={onSignOut} sx={{ color: 'text.secondary', flexShrink: 0 }}><LogoutOutlinedIcon fontSize="small" /></IconButton>
    </Tooltip>
  );
  if (compact) {
    return (
      <Stack sx={{ py: 1.5, gap: 1, alignItems: 'center', borderTop: 1, borderColor: 'divider' }}>
        <Tooltip title={`${name}, ${roleLabel}`} placement="right"><Box><Initials name={name} size={32} /></Box></Tooltip>
        {signOut}
      </Stack>
    );
  }
  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 1.25, m: 1.5, p: 1, pr: 0.5, borderRadius: 1.5, bgcolor: 'background.paper', border: 1, borderColor: 'divider' }}>
      <Initials name={name} size={32} />
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography variant="body2" noWrap sx={{ fontWeight: 500, lineHeight: 1.3 }}>{name}</Typography>
        <Typography variant="caption" noWrap sx={{ display: 'block', textTransform: 'capitalize', lineHeight: 1.3 }}>{roleLabel}</Typography>
      </Box>
      {signOut}
    </Stack>
  );
}
